
export function validatePattern(pattern, value) {
    return pattern.test(value);
}